export function getGuardianStatus(score) {
  const normalizedScore = Number.isFinite(Number(score)) ? Number(score) : 0;

  if (normalizedScore >= 90) {
    return {
      level: "excellent",
      label: "Exzellent",
      message: "Portfolio-Struktur ist sehr robust und breit abgesichert.",
    };
  }

  if (normalizedScore >= 75) {
    return {
      level: "stable",
      label: "Stabil",
      message: "Portfolio ist aktuell stabil, nur leichte Schwankungen erwartet.",
    };
  }

  if (normalizedScore >= 60) {
    return {
      level: "warning",
      label: "Beobachten",
      message: "Leichte Warnzeichen erkannt. Entwicklung enger beobachten.",
    };
  }

  if (normalizedScore >= 45) {
    return {
      level: "risk",
      label: "Erhöhtes Risiko",
      message: "Risikofaktoren nehmen zu. Positionierung überprüfen.",
    };
  }

  return {
    level: "critical",
    label: "Kritisch",
    message: "Kritische Lage. Schutzmaßnahmen und Rebalancing empfohlen.",
  };
}
